import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-battery',
  templateUrl: './home-battery.component.html',
  styleUrls: ['./home-battery.component.scss'],
})
export class HomeBatteryComponent implements OnInit {

  @Input() soc: number = 0.5

  constructor() { }

  ngOnInit() {}

  // return the icon from the material library that best matches the soc
  get imgSrc() {
    return 'assets/icons/material/large/' + this.iconName(this.soc)
  }

  iconName(soc: number): string {
    if (soc > 0.98) return 'battery-full.svg'
    if (soc > 0.85) return 'battery-6-bar.svg'
    if (soc > 0.70) return 'battery-5-bar.svg'
    if (soc > 0.50) return 'battery-4-bar.svg'
    if (soc > 0.35) return 'battery-3-bar.svg'
    if (soc > 0.20) return 'battery-2-bar.svg'
    if (soc > 0.05) return 'battery-1-bar.svg'
    return 'battery-0-bar.svg'
  }
}
